export const SET_SEND_EVENTS_ARR = 'SET_SEND_EVENTS_ARR';
